<!--
 * @Description: 赛道动态
 * @Author:  单珊珊
 * @Date: 2022-02-17 09:44:05
 * @LastEditTime: 2022-07-07 09:54:57
 * @LastEditors:  
-->
<template>
  <!-- 赛道动态 -->
  <div class="company-filter">
    <div class="common-container">
      
      <div class="left-wrap">
        <div class="header">
          <div class="left title-underline">赛道动态</div>
          <div class="right">
            <Select v-model="tag_id" @on-change="onChnage($event)" :label-in-value="true">
              <Option v-for="item in entity_ntag" :value="item.id - 0" :key="item.id">{{ item.name }}</Option>
            </Select>
          </div>
        </div>
        <div class="lasted-updated">
          <div class="updated-item-wider">
            <div class="item-title orange" v-if="!loading">
              <!-- <p class="common-title-p">{{ entity_ntag_name }}</p> -->
              <div class="item-title__left">
                <p class="left__upper">赛道动态</p>
                <p class="left__under">{{ entity_ntag_name }}</p>
              </div>
              <div class="item-title__right">
              </div>
            </div>
            <div class="list-wrap">
              <div class="item-list-wider" v-for="item,index in list" :key="index">
                <div class="legend">
                  <div class="type">{{ item.contnet_type_name }}</div>
                  <div class="time">{{ item.sort_time | time_moment}}<template v-if="item.content_type == 3 && item.sort_time">更新</template></div>
                </div>
                <div class="list-title-large" @click="goToDetail(item)">{{ item.title }}</div>
              </div>
            </div>
            <Spin v-if="loading">
              <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
              <div>Loading</div>
            </Spin>
            <div class="defalut" v-if="!loading && list.length < 1">
              <img :src="$store.state.static_img_url+'pic/quesheng-2.png'" alt="" srcset="">
              <p>暂无相关内容</p>
            </div>
            <div class="more-btn" v-if="length == 20 && !loading">
              <div @click="getMoreList">加载更多</div>
            </div>
          </div>
        </div>
      </div>
      <RightModel class="right-wrap">
        <rcTrack></rcTrack>
        <activeTrack class="item"></activeTrack>
        <activeAgency class="item"></activeAgency>
        <prospectus class="item"></prospectus>
      </RightModel>
    </div>
  </div>
</template>

<script>
import prospectus from './components/Prospectus'
import activeAgency from '@/components/vcbeat/ActiveAgency.vue'
import activeTrack from '@/components/vcbeat/Activetrack.vue'
import rcTrack from '@/components/vcbeat/RCtrack.vue'
import { getMeta, getNewslist } from '@/service.js'
import RightModel from '@/components/RightModel'
import filter from 'js/filter'
export default {
  components: { prospectus, activeAgency, activeTrack, rcTrack, RightModel },
  data() {
    return {
      entity_ntag: [],
      entity_ntag_name: [],
      tag_id: '',
      list: [],
      current_page_index: 1,
      length: 0,
      loading: true,
      more: false,
      content_type: [
        {
          id: 0,
          name: '文章'
        },
        {
          id: 1,
          name: '视频'
        },
        {
          id: 3,
          name: '专题Pro'
        },
        {
          id: 4,
          name: '快讯'
        },
      ]
    }
  },
  created() {
  },
  beforeMount() {
    this.getMeta()
    // this.getNewslist()
  },
  mounted() {

  },
  computed: {
  },
  methods: {
    //获取赛道列表
    async getMeta() {
      let res = await getMeta({ name: ['entity_ntag'] }, (error) => {
        this.$Message.error('元数据请求错误！')
      })
      if (res.status == 'success') {
        this.entity_ntag = res.meta.entity_ntag
        if (this.$route.query.id) {
          this.tag_id = this.$route.query.id - 0
          this.entity_ntag_name = filter.dealNeed(this.tag_id, this.entity_ntag)
          
        } else {
          this.tag_id = res.meta.entity_ntag[0].id
          this.entity_ntag_name = res.meta.entity_ntag[0].name
        }
        console.log('tag_id', this.tag_id)
        this.getNewslist()
      }
    },
    //获取赛道动态列表
    async getNewslist() {
      let tag_ids = []
      this.length = 0
      this.loading = true
      tag_ids.push(this.tag_id)
      let res = await getNewslist({ page: this.current_page_index, tag_ids: tag_ids }, (error) => {
        this.$Message.error('请求错误！')
      })
      this.loading = false
      if (res.code == 0) {
        this.length = res.data.length
        this.$set(this.$data, 'list', [...this.list, ...res.data])
        this.list.map(item => {
          this.$set(item, 'contnet_type_name', filter.dealNeed(item.content_type, this.content_type))
        })
      }
    },
    getMoreList() {
      if (this.length == 20) {
        ++this.current_page_index
        this.getNewslist()
      }
    },
    onChnage(event) {
      this.list = []
      this.current_page_index = 1
      this.entity_ntag_name = event.label
      this.tag_id = event.value
      this.getNewslist()
    },
    // 滚动条防抖
    debounce(fn, wait) {
      let timeout = null
      return () => {
        if (timeout !== null) {
          clearTimeout(timeout)
        }
        timeout = setTimeout(fn, wait)
      }
    },
    //跳转至文章、视频。快讯、专题详情
    goToDetail(item) {
      console.log(item)
      switch (item.content_type) {
        case 0:
          const temp_href = this.$store.state.index2_path + '/' + item.content_id
          window.open(temp_href, '_blank')
          break;
        case 1: 
          const temp_href1 = this.$store.state.index2_path + '/' + item.content_id
          window.open(temp_href1, '_blank')
          break
        case 3:
          const { href } = this.$router.resolve({ name: "SpecialDetail",params: {uid: item.uid}})
          window.open(href, '_blank')
          break;
        case 4:
          const href2 = this.$store.state.index2_path + '/newsDetail/' + item.uid
          window.open(href2, '_blank')
          break;
      }
    },
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common_track.stylus'
@import '~styles/common_vcbeat.stylus'
.company-filter
  background #fff
  display flex
  justify-content center
.common-container
  width 1200px
  margin 20px auto
  .left-wrap
    width 866px
    margin-right 30px
  .lasted-updated
    width 100%
  .right-wrap
    width 304px
    .item
      margin-top 30px
  >>>.ivu-select-selection
    border none
    background none
  >>>.ivu-select-visible
    .ivu-select-selection
      box-shadow none
  >>>.ivu-icon-ios-arrow-down
    &:before
      content '\F33D'
  >>>.ivu-select-selected-value
    font-size 14px
    
    font-weight 500
    color #666666
  >>>.ivu-select-item-selected
    color #FA5A00
  .defalut
    display flex
    flex-direction column
    align-items center
    img
      height 156px
    p
      color #999
      font-size 14px
  >>>.ivu-spin
    margin-top 20px
    color #FA5A00
  .more-btn
    // margin-top 20px
    display flex
    justify-content center
    > div
      width 136px
      height 40px
      background #FFFFFF
      border 1px solid #FA5A00
      border-radius 20px
      display flex
      justify-content center
      align-items center
      font-size 14px
      color #FA7A50
      cursor pointer
      transition all 0.2s
      &:hover
        background #FA5A00
        color #FFFFFF
</style>
